import { gql } from "@apollo/client";

const BACKFILLS_LIST_QUERY = gql`
  query backfills(
    $id: String
    $ids: [String]
    $status: String
    $report_datetime_after: DateTime
    $report_datetime_before: DateTime
    $created_datetime_after: DateTime
    $created_datetime_before: DateTime
    $search: String
    $first: Int
    $after: String
    $last: Int
    $before: String
  ) {
    backfills(
      id: $id
      ids: $ids
      status: $status
      report_datetime_after: $report_datetime_after
      report_datetime_before: $report_datetime_before
      created_datetime_after: $created_datetime_after
      created_datetime_before: $created_datetime_before
      search: $search
      first: $first
      after: $after
      last: $last
      before: $before
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          id
          status
          title
          upload_names
          download_names
          created_by {
            name
            email
          }
          created_on
          cancelled_by {
            name
            email
          }
          cancelled_on
          start_datetime
          end_datetime
          total_pipelines
          succeeded_pipelines
          failed_pipelines
          cancelled_pipelines
          hasDirtyRows
        }
      }
    }
  }
`;

const BACKFILL_DETAIL = gql`
  query backfill_detail($backfill_id: String!) {
    backfill(id: $backfill_id) {
      id
      status
      title
      start_datetime
      end_datetime
      description
      cancelled_pipelines
      total_pipelines
      succeeded_pipelines
      failed_pipelines
      created_by {
        name
        email
      }
      cancelled_by {
        name
        email
      }
      download_names
      upload_names
      subgraph {
        download_declarations {
          bundle_name
          tables {
            name
            exports {
              name
            }
          }
        }
        upload_declarations {
          name
        }
      }
      created_on
      cancelled_on
      hasDirtyRows
    }
  }
`;

const BACKFILL_RUNS = gql`
  query backfill_flows(
    $backfill_id: String
    $first: Int
    $after: String
    $last: Int
    $before: String
    $status: String
    $phase: String
    $sortDirection: SortDirection
  ) {
    flows(
      backfill_id: $backfill_id
      first: $first
      after: $after
      last: $last
      before: $before
      status: $status
      phase: $phase
      sortDirection: $sortDirection
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          id
          changelist {
            id
            description
          }
          launched_by {
            name
            email
          }
          created
          failed
          phase
          report_datetime {
            short
            long
            long_utc
            iso
          }
          status
          inputs {
            name
            source_table {
              id
              name
              project
              bundle {
                report_handle
                recent_failed_probe
                recent_successful_probe
                next_probe
              }
            }
            download {
              id
              report_datetime {
                short
                long
                long_utc
                iso
              }
              created
              started
              finished
              status
              handle
              progress
            }
            download_part {
              id
              row_count
              dirty_row_count
              dirty_row_status
              legacy_flow_source_id
              download {
                id
                handle
                status
                finished
              }
            }
          }
          processing {
            id
            started
            finished
            status
          }
          outputs {
            id
            name
            project
            handle
            row_count
            created
            started
            finished
            status
            report_datetime {
              short
              long
              long_utc
              iso
            }
            declaration {
              id
            }
          }
        }
      }
    }
  }
`;

const BACKFILL_MESSAGES = gql`
  query backfill_messages(
    $backfill_id: String
    $search: String
    $created_before: Date
    $created_after: Date
    $severity: String
    $first: Int
    $after: String
    $last: Int
    $before: String
  ) {
    events(
      backfill_id: $backfill_id
      search: $search
      created_before: $created_before
      created_after: $created_after
      severity: $severity
      first: $first
      after: $after
      last: $last
      before: $before
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          created
          severity
          message
          project_name
          download {
            id
          }
          flow {
            id
          }
          upload {
            id
          }
          will_retry
          comment
          commented_on
          commented_by {
            name
          }
        }
      }
    }
  }
`;

export { BACKFILL_DETAIL, BACKFILL_MESSAGES, BACKFILL_RUNS, BACKFILLS_LIST_QUERY };
